module.exports = __webpack_public_path__ + "img/publicity_2.6d353da0.jpg";